
import React from 'react';
import GuessTale from 'views/GivingTree';

const KindergartenPage = () => {
  return <GuessTale/>;
};

export default KindergartenPage;
